// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a0efd8a0","847":"a6130c1f"}[chunkId] + ".chunk.js";
};